import { useQuery } from '@tanstack/react-query';
import API from '../../../../utils/api';

export const useOpenpayCards = () => {
  return useQuery(
    ['/openpay-cards'],
    async () => (await API.fetchOpenPayCards())?.data?.cards || []
  );
};
